<template>
    <div class="col-12" id="frame">
        <div class="alert alert-success" v-if="showAlarm">
            <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
            <span>
                <b>{{ alarm }}</b>
            </span>
        </div>
        <div class="alert alert-success" v-if="showDelete">
            <span>
                <center>
                    <b>Reihentermine werden gelöscht! Dies kann bis zu 1 Min. dauern.</b>
                    <br />
                    <v-progress-circular :size="70" :width="7" color="red" indeterminate></v-progress-circular>
                </center>
            </span>
        </div>
        <div class="card">
            <div class="card-header text-xs-inline">
                <h4 class="card-title">
                    {{ title }}
                </h4>
                <p class="card-category tablecard" id="subtitle">
                    Bestelldetails
                    <span class="float-right">K.-Nr.: {{ bestellung.Kundennummer }}</span>
                </p>
                <span id="time">
                    <center>
                        {{ bestellung.Datum }} | {{ zeit }} Uhr
                        <p class="card-category tablecard">{{ bestellung.Strasse }} {{ bestellung.Hausnummer }}, {{ bestellung.PLZ }} {{ bestellung.Stadt }}</p>
                    </center>
                    <hr />
                </span>
            </div>

            <div class="card-body" id="cardbody">
                <center>
                    <!-- <ul class="list-group list-group-flush"> -->
                    <table v-if="bestellung.Selbsteinkaeufer == 1 || bestellung.Shop == 1">
                        <tr v-if="bestellung.Selbsteinkaeufer == 1">
                            <td><b>Selbsteinkäufer:</b></td>
                            <td><i class="material-icons">done</i></td>
                        </tr>
                        <tr v-if="bestellung.Shop == 1">
                            <td><b>Shop:</b></td>
                            <td><i class="material-icons">done</i></td>
                        </tr>
                        <center>
                            <div v-if="bestellung.Shop_Bemerkung">
                                Bemerkung:&nbsp;&nbsp;<br />
                                {{ bestellung.Shop_Bemerkung }}
                            </div>
                        </center>
                    </table>

                    <hr v-if="bestellung.Kisten == 1 || bestellung.Taschen == 1" />

                    <table v-if="bestellung.Kisten == 1 || bestellung.Taschen == 1">
                        <tr v-if="bestellung.Kisten == 1">
                            <td><b>Kisten: &nbsp;</b></td>
                            <td><i class="material-icons">done</i></td>
                            <td v-if="bestellung.Kisten_anzahl">&nbsp;{{ bestellung.Kisten_anzahl }}&nbsp;Stk.</td>
                        </tr>
                        <tr v-if="bestellung.Taschen == 1">
                            <td><b>Taschen:&nbsp;&nbsp;</b></td>
                            <td><i class="material-icons">done</i></td>
                            <td v-if="bestellung.Taschen_anzahl">&nbsp;{{ bestellung.Taschen_anzahl }}&nbsp;Stk.</td>
                        </tr>
                    </table>

                    <hr v-if="bestellung.TK == 1" />

                    <table v-if="bestellung.TK == 1">
                        <tr>
                            <td><b>Tiefkühl:</b></td>
                            <td><i class="material-icons">done</i></td>
                        </tr>
                        <center>
                            <div v-if="bestellung.TK_Anmerkung">
                                Bemerkung:&nbsp;&nbsp;<br />
                                {{ bestellung.TK_Anmerkung }}
                            </div>
                        </center>
                    </table>

                    <hr v-if="bestellung.Baecker == 1" />

                    <table v-if="bestellung.Baecker == 1">
                        <tr>
                            <td><b>Bäcker:</b></td>
                            <td><i class="material-icons">done</i></td>
                        </tr>
                        <center>
                            <div v-if="bestellung.Baecker_Bemerkung">
                                Bemerkung:&nbsp;&nbsp;<br />
                                {{ bestellung.Baecker_Bemerkung }}
                            </div>
                        </center>
                    </table>

                    <hr v-if="bestellung.Blumen == 1" />

                    <table v-if="bestellung.Blumen == 1">
                        <tr>
                            <td><b>Blumen:</b></td>
                            <td><i class="material-icons">done</i></td>
                        </tr>
                        <center>
                            <div v-if="bestellung.Blumen_Bemerkung">
                                Bemerkung:&nbsp;&nbsp;<br />
                                {{ bestellung.Blumen_Bemerkung }}
                            </div>
                        </center>
                    </table>

                    <!-- <hr v-if="bestellung.Blumen == 1">

                <table v-if="bestellung.Blumen == 1">
                    <tr>
                      <td><b>Blumen:</b></td>
                      <td><i class="material-icons">done</i></td>
                    </tr>
                   <center> <div v-if="bestellung.Blumen_Bemerkung">
                      Bemerkung:&nbsp;&nbsp;<br>
                      {{bestellung.Blumen_Bemerkung}}
                    </div>  
                     </center>               
                </table>
   -->

                    <div v-if="bestellung.Bestellbemerkung || bestellung.Bemerkung">
                        <hr />

                        <div v-if="bestellung.Bestellbemerkung"><b> Bestellinformationen: </b><br />{{ bestellung.Bestellbemerkung }}</div>
                        <div v-if="bestellung.Bemerkung"><b> Zusatzinformationen: </b><br />{{ bestellung.Bemerkung }}</div>
                    </div>
                    <div v-if="bestellung.Fahrerbemerkung">
                        <hr />
                        <div><b> Fahrerbemerkung: </b><br />{{ bestellung.Fahrerbemerkung }}</div>
                    </div>

                    <!-- </ul> -->
                </center>
                <hr />
                <span class="float-left">
                    <!-- dialog start -->
                    <v-dialog v-model="dialog" width="500">
                        <template v-slot:activator="{ on }">
                            <v-btn fab dark color="grey" v-on="on"><v-icon dark id="icons">settings</v-icon></v-btn>
                        </template>

                        <v-card>
                            <v-card-title class="headline grey lighten-2" primary-title> Einstellungen </v-card-title>

                            <v-list>
                                <v-list-tile @click="gotoWaren">
                                    <v-list-tile-action>
                                        <v-icon color="blue">remove_shopping_cart</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Warenrückgabe</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile @click="gotoPfand">
                                    <v-list-tile-action>
                                        <v-icon color="purple">keyboard_return</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Pfandrückgabe</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile v-if="allowedForDashboard || büro" @click="pushEdit(bestellung.Bestellnummer)">
                                    <v-list-tile-action>
                                        <v-icon color="green">edit</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Editieren</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile v-if="allowedForDashboard || büro" @click="deleteBestellung(bestellung.Bestellnummer)">
                                    <v-list-tile-action>
                                        <v-icon color="red">delete</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Termin löschen</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile v-if="(allowedForDashboard && bestellung.ReihenterminId) || (büro && bestellung.ReihenterminId)" @click="deleteReihentermin(bestellung.ReihenterminId)">
                                    <v-list-tile-action>
                                        <v-icon color="red">delete_sweep</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Reihentermin löschen</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <!-- nested dialog start-->
                                <v-dialog v-model="fahrerBemDialog" width="500">
                                    <template v-slot:activator="{ on }">
                                        <v-list-tile v-on="on">
                                            <v-list-tile-action>
                                                <v-icon color="yellow">info</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-content>
                                                <v-list-tile-title>Fahrer Bemerkung</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                    <v-card>
                                        <v-card-title class="headline grey lighten-2" primary-title> Fahrer-Bemerkung </v-card-title>
                                        <v-card-text>
                                            <v-textarea box focus label="Bitte nützliche Bemerkung eingeben" v-model="fahrerBemerkung"></v-textarea>
                                        </v-card-text>
                                        <v-divider />
                                        <v-card-actions>
                                            <v-btn dark color="green" @click="fahrerBemSpeichern" block>speichern</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <!-- nested dialog end-->
                            </v-list>
                        </v-card>
                    </v-dialog>
                    <!-- dialog end -->
                </span>

                <span class="float-right">
                    <v-btn fab dark color="blue" v-on:click="gotoMaps(bestellung.Strasse, bestellung.Hausnummer, bestellung.PLZ, bestellung.Stadt)">
                        <v-icon id="icons" dark>navigation</v-icon>
                    </v-btn>

                    <v-btn fab dark color="green" v-bind:href="'tel:' + bestellung.Telefon">
                        <v-icon id="phone" dark>phone</v-icon>
                    </v-btn>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import firebase from "firebase"
    const moment = require("moment")
    export default {
        data() {
            return {
                auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
                bemerkungSaved: false,
                fahrerBemDialog: false,
                fahrerBemerkung: "",
                bestellung: {},
                title: "",
                kunde: { Nachname: "Dummy" },
                dialog: false,
                dialog1: false,
                alarm: "",
                showAlarm: false,
                showDelete: 0,
                kunde: {},
                terminArray: [],
                zeit: "",
                datum: "",
                allowedForDashboard: false,
                isLoggedIn: false,
                // uhl: false,
                fahrer: false,
                büro: false,
                uhlmail: "t.uhl@rewe-uhl.de",
                fahrermails: ["fahrer1@heimspiel.de", "fahrer2@heimspiel.de"],
                büromail: "buero@heimspiel.de"
            }
        },

        methods: {
            fahrerBemSpeichern() {
                let data = {
                    Kundennummer: this.bestellung.Kundennummer,
                    Fahrerbemerkung: this.fahrerBemerkung,
                    auth: process.env.VUE_APP_PHP_AUTH
                }
                this.$http.post(process.env.VUE_APP_PHP_API_URL + "/fahrerbemerkung", data).then(function (response) {
                    this.dialog = false
                    this.fahrerBemDialog = false
                    this.bemerkungSaved = true
                    this.bestellung.Fahrerbemerkung = this.fahrerBemerkung
                    console.log(response)
                })
            },
            deleteReihentermin(id) {
                this.dialog = false
                this.showDelete = 1
                this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/deleteRow/" + id, {}, { headers: { Authorization: this.auth } }).then(function (response) {
                    console.log(response)
                    this.terminArray = response.body.data
                    var i = 0
                    // this.deleteRowTermin(i, this.terminArray);
                    setTimeout(function () {
                        that.$router.push({
                            path: "/tagestour",
                            query: { alarm: "Reihentermine gelöscht!" }
                        })
                    }, 1000)
                })

                //
            },
            deleteRowTermin: _.debounce(function (i, terminArray) {
                var that = this
                this.deleteTermin(terminArray[i].id, terminArray[i].kalender)
                console.log(i)
                if (i < terminArray.length - 1) {
                    this.deleteRowTermin(i + 1, terminArray)
                } else {
                    setTimeout(function () {
                        that.$router.push({
                            path: "/tagestour",
                            query: { alarm: "Reihentermine gelöscht!" }
                        })
                    }, 1000)
                }
            }, 450),

            gotoWaren() {
                this.$router.push("/waren/" + this.bestellung.Kundennummer)
            },
            gotoPfand() {
                this.$router.push("/pfand/" + this.bestellung.Kundennummer)
            },
            fetchTermin(id) {
                this.$http.post(process.env.VUE_APP_PHP_API_URL + "/bestellung/" + id, { auth: process.env.VUE_APP_PHP_AUTH }).then(function (response) {
                    console.log(response)
                    this.bestellung = response.body
                    this.datum = moment(this.bestellung.Datum, "LTS").format("LT")
                    this.zeit = this.bestellung.Uhrzeit.substring(0, 5)
                    this.fahrerBemerkung = this.bestellung.Fahrerbemerkung
                    if (this.bestellung.Firma.length < 2) {
                        this.title = this.bestellung.Nachname
                    } else {
                        this.title = this.bestellung.Firma
                    }
                })
            },
            disableNotification() {
                this.showAlarm = !this.showAlarm
            },
            gotoMaps(Strasse, Hausnummer, PLZ, Stadt) {
                window.location.href = "https://www.google.com/maps/dir/?api=1&destination=" + Strasse + "+" + Hausnummer + "+" + PLZ + "+" + Stadt + "+Germany&travelmode=driving"
            },
            pushEdit(bestellnummer) {
                this.$router.push("/editbestellung/" + bestellnummer)
            },
            deleteBestellung(bestellnummer) {
                this.$http.post(process.env.VUE_APP_PHP_API_URL + "/bestellung/delete/" + bestellnummer, { auth: process.env.VUE_APP_PHP_AUTH }).then(function (response) {
                    // this.deleteTermin(this.bestellung.id, this.bestellung.kalender)
                    this.$router.push({
                        path: "/tagestour",
                        query: { alarm: "Bestellung gelöscht!" }
                    })
                })
            },
            deleteTermin(terminId, kalender) {
                this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/delete/termin", { id: terminId, type: kalender }, { headers: { Authorization: this.auth } }).then(function (response) {
                    // console.log(response);
                })
            }
        },

        created: function () {
            this.fetchTermin(this.$route.params.bestellnr)
            if (this.$route.query.alarm) {
                this.alarm = this.$route.query.alarm
                this.showAlarm = true
            }

            if (firebase.auth().currentUser) {
                this.isLoggedIn = true
                var mail = firebase.auth().currentUser.email
                if (mail === this.uhlmail) {
                    this.allowedForDashboard = true
                } else if (mail === this.büromail) {
                    this.büro = true
                } else if (mail === this.fahrermails[0] || mail === this.fahrermails[1]) {
                    this.fahrer = true
                }
            }
        },
        components: {}
        // updated: function(){
        // }
    }
</script>

<style scoped>
    #phone {
        position: absolute;
        top: 15px;
        left: 15px;
    }
    /* #icons{
  position: absolute;
  top: 15px;
} */
    #time {
        text-align: center;
        font-weight: bold;
        font-size: 120%;
    }
    #subtitle {
        padding-bottom: 20px;
        padding-left: 3px;
    }
    #frame {
        padding-left: 0px;
        padding-right: 0px;
    }
    .alert {
        border-radius: 7px 7px 7px 7px;
        text-align: center;
    }
    #cardbody {
        padding-top: 0%;
    }
    /* #items{
  text-align: left;
} */
    /* #checks{
 float: right;
} */
</style>
